import React, {createContext, useReducer} from 'react'

export const SET_SALES_CODE_LIST = 'SET_SALES_CODE_LIST'
export const SELECT_SALES_CODE = 'SELECT_SALES_CODE'
export const SET_SHOW_SALES_CODE_POPUP = 'SET_SHOW_SALES_CODE_POPUP'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_SALES_CODE_LIST:
      return { ...data, sales_code_list: payload.data }
    case SELECT_SALES_CODE:
      return {
        ...data,
        selected_sales_code: payload.data.selected_sales_code,
        show_sales_code_popup: payload.data.show_sales_code_popup,
      }
    case SET_SHOW_SALES_CODE_POPUP:
      return {
        ...data,
        show_sales_code_popup: payload.data,
        selected_sales_code: payload.data ? data.selected_sales_code : {},
      }
    default:
      return data
  }
}

const initialState = {
  sales_code_list: [],
  selected_sales_code: {},
  show_sales_code_popup: false,
}

const SalesCodeStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <SalesCodeContext.Provider value={[state, dispatch]}>
      {children}
    </SalesCodeContext.Provider>
  )
}

export const SalesCodeContext = createContext(initialState)
export default SalesCodeStore
